import React from 'react';
import { NavLink } from 'react-router-dom';
import { IPlace } from '../../../models/interfaces/IPlace';
import { checkImage } from '../../componentUtils';
import { Index } from '../../TrailPage/Waypoints/waypointStyles';
import LoadingImage from '../../Global/LoadingImage/LoadingImage';
import { generatePlaceMetaString } from '../../newComponentUtils';
import {
	StoryPlaceContainer,
	StoryPlaceDescription,
	StoryPlaceImgContainer,
	StoryPlaceIndex,
	StoryPlaceMeta,
	StoryPlaceTextContainer,
} from './storyPlacesStyles';
import BookmarkPlaceButton from '../../Global/BookmarkButton/BookmarkPlaceButton';

type StoryPlaceProps = {
	place: IPlace;
	ndx: number;
};
const StoryPlace: React.FC<StoryPlaceProps> = ({ place, ndx }) => {
	return (
		<StoryPlaceContainer>
			<StoryPlaceImgContainer>
				<NavLink to={'/place/' + place.id}>
					<StoryPlaceImgContainer>
						<LoadingImage src={checkImage(place.image)} />
					</StoryPlaceImgContainer>
				</NavLink>

				{place.id && <BookmarkPlaceButton placeId={place.id} />}
			</StoryPlaceImgContainer>
			<StoryPlaceTextContainer>
				<h3>
					<StoryPlaceIndex>{ndx + 1}</StoryPlaceIndex>
					{place.title}
				</h3>
				<StoryPlaceMeta>
					{generatePlaceMetaString(place)}
				</StoryPlaceMeta>
				<StoryPlaceDescription>
					{place.short_description}
				</StoryPlaceDescription>
			</StoryPlaceTextContainer>
		</StoryPlaceContainer>
	);
};

export default StoryPlace;
